export const APP_NAME = 'Rostric';
export const PERSIST_STORE_NAME = 'admin';
export const PERSIST_STORE_ENCRYPTION_KEY = 'Resstric-auth-storage-encryption-key';
export const REDIRECT_URL_KEY = 'redirectUrl';
